/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerCreate } from '../fn/admin/admin-controller-create';
import { AdminControllerCreate$Params } from '../fn/admin/admin-controller-create';
import { adminControllerDelete } from '../fn/admin/admin-controller-delete';
import { AdminControllerDelete$Params } from '../fn/admin/admin-controller-delete';
import { adminControllerFindAll } from '../fn/admin/admin-controller-find-all';
import { AdminControllerFindAll$Params } from '../fn/admin/admin-controller-find-all';
import { adminControllerFindById } from '../fn/admin/admin-controller-find-by-id';
import { AdminControllerFindById$Params } from '../fn/admin/admin-controller-find-by-id';
import { adminControllerFindLogs } from '../fn/admin/admin-controller-find-logs';
import { AdminControllerFindLogs$Params } from '../fn/admin/admin-controller-find-logs';
import { adminControllerFindMe } from '../fn/admin/admin-controller-find-me';
import { AdminControllerFindMe$Params } from '../fn/admin/admin-controller-find-me';
import { adminControllerLogout } from '../fn/admin/admin-controller-logout';
import { AdminControllerLogout$Params } from '../fn/admin/admin-controller-logout';
import { adminControllerRefresh } from '../fn/admin/admin-controller-refresh';
import { AdminControllerRefresh$Params } from '../fn/admin/admin-controller-refresh';
import { adminControllerSearchCursor } from '../fn/admin/admin-controller-search-cursor';
import { AdminControllerSearchCursor$Params } from '../fn/admin/admin-controller-search-cursor';
import { adminControllerSearchOffset } from '../fn/admin/admin-controller-search-offset';
import { AdminControllerSearchOffset$Params } from '../fn/admin/admin-controller-search-offset';
import { adminControllerSignin } from '../fn/admin/admin-controller-signin';
import { AdminControllerSignin$Params } from '../fn/admin/admin-controller-signin';
import { adminControllerSignup } from '../fn/admin/admin-controller-signup';
import { AdminControllerSignup$Params } from '../fn/admin/admin-controller-signup';
import { adminControllerUpdate } from '../fn/admin/admin-controller-update';
import { AdminControllerUpdate$Params } from '../fn/admin/admin-controller-update';
import { AdminDto } from '../models/admin-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { LogDto } from '../models/log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerFindAll()` */
  static readonly AdminControllerFindAllPath = '/api/admins';

  /**
   * 관리자 전체 조회.
   *
   * 모든 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll$Response(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
    return adminControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 전체 조회.
   *
   * 모든 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindAll(params?: AdminControllerFindAll$Params, context?: HttpContext): Observable<Array<AdminDto>> {
    return this.adminControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AdminDto>>): Array<AdminDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerCreate()` */
  static readonly AdminControllerCreatePath = '/api/admins';

  /**
   * 관리자 생성.
   *
   * 관리자을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate$Response(params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 생성.
   *
   * 관리자을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate(params: AdminControllerCreate$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerFindMe()` */
  static readonly AdminControllerFindMePath = '/api/admins/me';

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindMe$Response(params?: AdminControllerFindMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerFindMe(this.http, this.rootUrl, params, context);
  }

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindMe(params?: AdminControllerFindMe$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerFindMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchOffset()` */
  static readonly AdminControllerSearchOffsetPath = '/api/admins/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   * 관리자을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset$Response(params?: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AdminDto>;
}>> {
    return adminControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   * 관리자을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset(params?: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<AdminDto>;
}> {
    return this.adminControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AdminDto>;
}>): OffsetPaginationDto & {
'items'?: Array<AdminDto>;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchCursor()` */
  static readonly AdminControllerSearchCursorPath = '/api/admins/search/cursor';

  /**
   * 관리자 커서 기반 조회.
   *
   * 관리자을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchCursor$Response(params?: AdminControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<AdminDto>;
}>> {
    return adminControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 커서 기반 조회.
   *
   * 관리자을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchCursor(params?: AdminControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<AdminDto>;
}> {
    return this.adminControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<AdminDto>;
}>): CursorPaginationDto & {
'items'?: Array<AdminDto>;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerFindLogs()` */
  static readonly AdminControllerFindLogsPath = '/api/admins/{id}/logs';

  /**
   * 관리자 로그 조회.
   *
   * 특정 관리자의 로그를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindLogs$Response(params: AdminControllerFindLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LogDto>;
}>> {
    return adminControllerFindLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 조회.
   *
   * 특정 관리자의 로그를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindLogs(params: AdminControllerFindLogs$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LogDto>;
}> {
    return this.adminControllerFindLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LogDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LogDto>;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerFindById()` */
  static readonly AdminControllerFindByIdPath = '/api/admins/{id}';

  /**
   * 관리자 ID 기반 조회.
   *
   * 관리자을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById$Response(params: AdminControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 ID 기반 조회.
   *
   * 관리자을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById(params: AdminControllerFindById$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDelete()` */
  static readonly AdminControllerDeletePath = '/api/admins/{id}';

  /**
   * 관리자 삭제.
   *
   * 관리자을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete$Response(params: AdminControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 삭제.
   *
   * 관리자을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete(params: AdminControllerDelete$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerUpdate()` */
  static readonly AdminControllerUpdatePath = '/api/admins/{id}';

  /**
   * 관리자 수정.
   *
   * 관리자를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate$Response(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 수정.
   *
   * 관리자를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSignin()` */
  static readonly AdminControllerSigninPath = '/api/admins/signin';

  /**
   * 관리자 로그인.
   *
   * 관리자를 로그인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignin$Response(params: AdminControllerSignin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    return adminControllerSignin(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그인.
   *
   * 관리자를 로그인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignin(params: AdminControllerSignin$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    return this.adminControllerSignin$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerSignup()` */
  static readonly AdminControllerSignupPath = '/api/admins/signup';

  /**
   * 관리자 회원가입.
   *
   * 관리자를 회원가입합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignup$Response(params: AdminControllerSignup$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerSignup(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 회원가입.
   *
   * 관리자를 회원가입합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignup(params: AdminControllerSignup$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerSignup$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerRefresh()` */
  static readonly AdminControllerRefreshPath = '/api/admins/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerRefresh()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh$Response(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerRefresh(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerRefresh$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerRefresh$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerLogout()` */
  static readonly AdminControllerLogoutPath = '/api/admins/logout';

  /**
   * 관리자 로그아웃.
   *
   * 관리자를 로그아웃합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout$Response(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그아웃.
   *
   * 관리자를 로그아웃합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

}
